import tmhRequest from '@/config/tmhRequest'

export default {
    searchRefundServiceOrderReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/refundserviceorderreport/searchrefundserviceorderreportcount',
            method: 'post',
            data: data,
        })
    },
    searchRefundServiceOrderReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/refundserviceorderreport/searchrefundserviceorderreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportRefundServiceOrderReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/refundserviceorderreport/exportrefundserviceorderreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/refundserviceorderreport.js